import React, { useState } from "react";
import "./cancelledModal.scss";
import CLOSE_ICON from "../../Images/closed.png";

const CancelledModal = (props) => {
  const { closeModal, CancelledTraining } = props;
  const [cancelReason, setCancelReason] = useState();

  return (
    <div id="myModal" className="cancelled-Modal">
      <div className="cancelled-Modal-content">
        {/* <img src={CLOSE_ICON} className="close_icon" onClick={closeModal} /> */}
        <h3>Cancel Training</h3>
        <p>Are you sure you want to Cancel Training?</p>
        <div>
          <textarea
            rows={4}
            placeholder="Enter cancellation reason"
            onChange={(e) => setCancelReason(e.target.value)}
          ></textarea>
        </div>
        <div className="cancelled_button_div">
          <button
            className="canclled_button medium_f"
            disabled={!cancelReason}
            onClick={() => CancelledTraining({ cancelReason })}
          >
            Cancel Session
          </button>
          <button className="close_button medium_f" onClick={closeModal}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelledModal;
